<body>
  <!-- app menu -->
  <app-nav-menu></app-nav-menu>

  <div id="page-container">
    <!-- router content -->
    <div class="container-fluid router-content">
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer></app-footer>
  </div>
</body>
